import { ComplianceBucketStatus } from '@commenda/types/src/compliance/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useComplianceBuckets(corporationId: number) {
  const {
    data,
    error,
    mutate,
  }: {
    data: ComplianceBucketStatus[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `compliance/category-status/${corporationId}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
